module.exports = __webpack_public_path__ + "img/thumb_25.71e38567.jpg";